import SmartMatchPlugin from "./SmartMatchPlugin.vue";

export default SmartMatchPlugin;
